export default "/assets/gosh.svg";